import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';

import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'


import SvgPatternBackground from '../Components/svgPatternBackground';

import classes from '../Pages/AboutAppPage.module.css'

export default function AboutAppPage({language}) {

    function createMarkup(str) {
        return {__html: str};
    }

    const [jwt, setJwt] = useState("")
    const [pageContent, setPageContent] = useState({})
    const [currentTermCount, setCurrentTermCount] = useState()

    const [currentOSInfo, setCurrentOSInfo] = useState("Android")

    const [isLoadingContent, setIsLoadingContent] = useState(false)

    const [loadedImg, setLoadedImg] = useState(false);
    const [loadedImg2, setLoadedImg2] = useState(false);
    const [loadedImg3, setLoadedImg3] = useState(false);
    const [loadedImg4, setLoadedImg4] = useState(false);

    useEffect(() => {
        setJwt(window.localStorage.getItem("jwt"))
        setIsLoadingContent(true)
        fetch(`${process.env.REACT_APP_API_STRAPI_URL}api/terms?fields[0]=id&locale=${language}&sort[0]=text%3Aasc`, { 
            'Content-Type': 'application/json' , method: 'GET' 
            })
            .then(data => data.json())
            .then(data => setCurrentTermCount(data.meta.pagination.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))

        fetch(`${process.env.REACT_APP_API_STRAPI_URL}api/about-app/?locale=${language}&populate=*`, { 
            'Content-Type': 'application/json' , method: 'GET' 
            })
            .then(data => data.json())
            .then(data => {
                setPageContent(data.data.attributes)
                setIsLoadingContent(false)
                
            })
    }, [language])
    return (
        <>
        <section>
            <SvgPatternBackground 
                scale={window.innerWidth < 600 ? '1.5' : '1'} 
                number={1} 
                height={window.innerWidth < 991 && window.innerHeight > 667  ? '1650px' : window.innerHeight <= 667 ? '1650px' : '100vh'} 
                color={'e8f1f0'} 
                angle={0} 
                backgroundColor={'#f5f5f6'}
            />
            <div className={classes.appFeatures}>
                <div className={classes.appFeaturesContent}>
                    <div className={`${classes.appFeaturesTitle} fade-center-top`}>
                        {
                            isLoadingContent
                            ?
                            <>
                            <Skeleton 
                                style={{width:'300px', height:'75px',margin:'35px'}}
                            />
                            </>
                            :
                            <>
                            <h1 style={{margin:'35px'}}>{pageContent.Tittle_app}</h1>
                            </>
                        }  
                    </div>
                    <div className={classes.appFeaturesFeatures}>
                        <div className={classes.appFeaturesSecond}>
                            <div className={`${classes.appFeatureCol1} reveal fade-bottom active`}>
                                <div className={classes.appFeaturesLogo}>
                                    <i className='icon-benefits icon-search'></i>
                                </div>
                                <div style={{width:'250px'}} className='body_text'>
                                {
                                    isLoadingContent
                                    ?
                                    <>
                                        <Skeleton 
                                            style={{width:'210px', height:'100px',}}
                                        />
                                    </>
                                    :
                                    <>
                                        <div dangerouslySetInnerHTML={createMarkup(pageContent.Characteristic_0)} />
                                    </>
                                }  
                                    
                                </div>
                            </div>
                            <div className={`${classes.appFeatureCol1} reveal fade-bottom active`}>
                                <div className={classes.appFeaturesLogo}>
                                    {WorldIcon()}
                                </div>
                                <div style={{width:'250px'}} className='body_text'>
                                {
                                    isLoadingContent
                                    ?
                                    <>
                                        <Skeleton 
                                            style={{width:'210px', height:'100px',}}
                                        />
                                    </>
                                    :
                                    <>
                                        <div dangerouslySetInnerHTML={createMarkup(pageContent.Characteristic_1)} />
                                    </>
                                }  
                                    
                                </div>
                            </div>
                            <div  className={`${classes.appFeatureCol1} reveal fade-bottom active`}>
                                <div className={classes.appFeaturesLogo}>
                                    {QuestionIcon()}
                                </div>
                                <div style={{width:'250px'}} className='body_text'>
                                {
                                    isLoadingContent
                                    ?
                                    <>
                                        <Skeleton 
                                            style={{width:'210px', height:'100px',}}
                                        />
                                    </>
                                    :
                                    <>
                                        <div dangerouslySetInnerHTML={createMarkup(pageContent.Characteristic_2)} />
                                    </>
                                } 
                                </div>
                            </div>
                        </div>
                        <div className={`${classes.appFeaturesFirst} reveal fade-bottom active`}>
                            {loadedImg ? null : (
                                <div
                                style={{
                                    background: 'trasparent',
                                    height: '496.5px',
                                    width: '400px'
                                }}
                                />
                            )}
                            <img
                                style={loadedImg ? {} : { display: 'none' }}
                                src={`https://strapi.accounting-a-z.ch${{...{...{...pageContent.cell_image}.data}.attributes}.url}`}
                                onLoad={() => setLoadedImg(true)}
                                className={classes.appFeaturesImage}
                            />
                        </div>
                        <div className={classes.appFeaturesThirdFeatureContainer}>
                            <div className={`${classes.appFeatureCol2} reveal fade-bottom active`}>
                                <div className={classes.appFeaturesLogo}>
                                    <i className='icon-benefits icon-addwatchlist-c'></i>
                                </div>
                                <div style={{width:'250px'}} className='body_text'>
                                {
                                    isLoadingContent
                                    ?
                                    <>
                                        <Skeleton 
                                            style={{width:'210px', height:'100px',}}
                                        />
                                    </>
                                    :
                                    <>
                                        <div dangerouslySetInnerHTML={createMarkup(pageContent.Characteristic_3)} />
                                    </>
                                }     
                                </div>
                                
                            </div>
                            <div className={`${classes.appFeatureCol2} reveal fade-bottom active`}>
                                <div className={classes.appFeaturesLogo}>
                                    <i className='icon-benefits icon-addwatchlist-c'></i>
                                </div>
                                <div style={{width:'250px'}} className='body_text'>
                                {
                                    isLoadingContent
                                    ?
                                    <>
                                        <Skeleton 
                                            style={{width:'210px', height:'100px',}}
                                        />
                                    </>
                                    :
                                    <>
                                        <div dangerouslySetInnerHTML={createMarkup(pageContent.Characteristic_4)} />
                                    </>
                                } 
                                </div>
                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <SvgPatternBackground 
                scale={window.innerWidth < 600 ? '1.5' : '1'} 
                number={2} 
                // height={window.innerWidth < 991 ? '165vh' : '100vh'} 
                height={window.innerWidth < 991 && window.innerHeight > 667  ? '1500px' : window.innerHeight <= 667 ? '1500px' : '850px'}
                color={'d7eeeb'} 
                angle={0} 
                backgroundColor={'#e0f2f0'}/>
            <div className={classes.CreateAccount}>
                <div className={classes.CreateAccountContent}>
                    <div style={{display:'flex', justifyContent:'center'}}>
                    {
                        isLoadingContent
                        ?
                        <>
                            <Skeleton 
                                style={{width:'400px', height:'30px', margin:'35px'}}
                            />
                        </>
                        :
                        <>
                            <h3 className={classes.CreateAccountTitle}>{pageContent.Account_title}</h3>
                        </>
                    }
                        
                    </div>
            
                    <div className={classes.gridContainer}>
                        <div id="1" className={classes.gridItem}>
                        {
                            isLoadingContent
                            ?
                            <>
                                <Skeleton 
                                    className={classes.FeatureSkeleton}
                                />
                            </>
                            :
                            <>
                                <div>{pageContent.Feature}</div>
                            </>
                        } 
                        </div>
                        <div id="2" className={classes.gridItem}>
                        
                            &nbsp; 
                            &nbsp; 
                            &nbsp; 
                            &nbsp; 
                            <svg width="22.1" height="20.8" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.29116 15.405C3.22449 15.405 3.15116 15.385 3.09783 15.3383C2.97783 15.2517 2.93116 15.105 2.97783 14.965L4.73783 9.55833L0.137826 6.21833C0.0178259 6.13166 -0.0288409 5.98499 0.0178257 5.84499C0.0644924 5.70499 0.191161 5.61166 0.337828 5.61166H6.02449L7.77782 0.205C7.86449 -0.0683333 8.32449 -0.0683333 8.41116 0.205L10.1645 5.61166H15.8512C15.9978 5.61166 16.1245 5.70499 16.1712 5.84499C16.2178 5.98499 16.1712 6.13166 16.0512 6.21833L11.4512 9.55833L13.2045 14.965C13.2512 15.105 13.2045 15.2517 13.0845 15.3383C12.9712 15.425 12.8112 15.425 12.6912 15.3383L8.09116 11.9983L3.49116 15.3383C3.43116 15.3783 3.3645 15.405 3.29783 15.405H3.29116ZM8.0845 11.2583C8.15116 11.2583 8.22449 11.2783 8.27782 11.325L12.2445 14.205L10.7312 9.54501C10.6845 9.40501 10.7312 9.25832 10.8512 9.17165L14.8178 6.29167H9.91783C9.77116 6.29167 9.64449 6.19833 9.59783 6.05833L8.0845 1.39834L6.57116 6.05833C6.52449 6.19833 6.39783 6.29167 6.25116 6.29167H1.35116L5.31783 9.17165C5.43783 9.25832 5.4845 9.40501 5.43783 9.54501L3.92449 14.205L7.89116 11.325C7.95116 11.285 8.01783 11.2583 8.0845 11.2583V11.2583Z" fill="#068B77"/>
                            </svg>
                            <span style={{marginLeft:'5px'}}>
                            {
                                isLoadingContent
                                ?
                                <>
                                    <Skeleton 
                                        className={classes.AccountSkeleton}
                                    />
                                </>
                                :
                                <>
                                    <div>{pageContent.Free}</div>
                                </>
                            } 
                            </span>
                            &nbsp; 
                            &nbsp; 
                            &nbsp; 
                            &nbsp; 
                        </div>
                        <div id="3" className={classes.gridItem}>
                            <svg width="22.1" height="20.8" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.29116 15.405C3.22449 15.405 3.15116 15.385 3.09783 15.3383C2.97783 15.2517 2.93116 15.105 2.97783 14.965L4.73783 9.55833L0.137826 6.21833C0.0178259 6.13166 -0.0288409 5.98499 0.0178257 5.84499C0.0644924 5.70499 0.191161 5.61166 0.337828 5.61166H6.02449L7.77782 0.205C7.86449 -0.0683333 8.32449 -0.0683333 8.41116 0.205L10.1645 5.61166H15.8512C15.9978 5.61166 16.1245 5.70499 16.1712 5.84499C16.2178 5.98499 16.1712 6.13166 16.0512 6.21833L11.4512 9.55833L13.2045 14.965C13.2512 15.105 13.2045 15.2517 13.0845 15.3383C12.9712 15.425 12.8112 15.425 12.6912 15.3383L8.09116 11.9983L3.49116 15.3383C3.43116 15.3783 3.3645 15.405 3.29783 15.405H3.29116ZM8.0845 11.2583C8.15116 11.2583 8.22449 11.2783 8.27782 11.325L12.2445 14.205L10.7312 9.54501C10.6845 9.40501 10.7312 9.25832 10.8512 9.17165L14.8178 6.29167H9.91783C9.77116 6.29167 9.64449 6.19833 9.59783 6.05833L8.0845 1.39834L6.57116 6.05833C6.52449 6.19833 6.39783 6.29167 6.25116 6.29167H1.35116L5.31783 9.17165C5.43783 9.25832 5.4845 9.40501 5.43783 9.54501L3.92449 14.205L7.89116 11.325C7.95116 11.285 8.01783 11.2583 8.0845 11.2583V11.2583Z" fill="#E0F2F0"/>
                            </svg>
                            <span style={{marginLeft:'5px'}}>
                            {
                                isLoadingContent
                                ?
                                <>
                                    <Skeleton 
                                        className={classes.AccountSkeleton}
                                    />
                                </>
                                :
                                <>
                                    <div>{pageContent.Basic}</div>
                                </>
                            } 
                            </span>
                        </div>  
                        <div id="4" className={classes.gridItem}>
                            <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.666645 13.0848L0.666645 0.334205C0.666645 0.234834 0.71884 0.141677 0.803633 0.085781C0.888426 0.0298849 0.992774 0.0112483 1.09713 0.0423017L9.69385 2.64458C9.83082 2.68805 9.92212 2.80606 9.92212 2.9427L9.92212 15.6932C9.92212 15.7926 9.86994 15.8858 9.78515 15.9417C9.70036 15.9975 9.59601 16.0162 9.49165 15.9851L0.894937 13.3829C0.757964 13.3394 0.666645 13.2214 0.666645 13.0848ZM1.3189 0.756527L1.3189 12.855L9.26336 15.2585L9.26336 3.16008L1.3189 0.756527Z" fill="#E0F2F0"/>
                                <path d="M0.696444 0.310534C0.696444 0.136635 0.83994 -4.87822e-07 1.02257 -4.79839e-07L11.3477 3.17572e-08C12 -4.56897e-07 12 0.310534 12 0.931602L12 2.74364L12 4.96855L12 6.21068L12 13.0611C12 13.235 11.8565 13.3716 11.6739 13.3716C11.4912 13.3716 11.3477 13.235 11.3477 13.0611L11.3477 7.76335L11.3477 5.27908L11.3477 3.72641L11.3477 2.17374L11.3477 0.931602L11.3477 0.621068L1.02257 0.621068C0.83994 0.621068 0.696444 0.484433 0.696444 0.310534Z" fill="#E0F2F0"/>
                            </svg>
                            <span style={{marginLeft:'5px'}}>
                            {
                                isLoadingContent
                                ?
                                <>
                                    <Skeleton 
                                        className={classes.AccountSkeleton}
                                    />
                                </>
                                :
                                <>
                                    <div>{pageContent.Book}</div>
                                </>
                            } 
                            </span>
                        </div>
                        <div id="5" className={classes.gridItem}>
                            <ul style={{margin:'0', height:'100%', display:'flex'}}>
                            {
                                isLoadingContent
                                ?
                                <>
                                    <Skeleton 
                                        className={classes.FeatureListSkeleton}
                                    />
                                </>
                                :
                                <>
                                    <li dangerouslySetInnerHTML={createMarkup(pageContent.Feature_1)}/>
                                </>
                            } 
                            </ul>
                        </div>
                        <div id="6" className={classes.gridItem}>
                            <span>{No()}</span>
                        </div>  
                        <div id="7" className={classes.gridItem}>
                            <span >{Yes()}</span>
                        </div>
                        <div id="8" className={classes.gridItem}>
                            <span >{Yes()}</span>
                        </div>
                        <div id="9" className={classes.gridItem}>
                            <ul style={{margin:'0', height:'100%', display:'flex'}}>
                            {
                                isLoadingContent
                                ?
                                <>
                                    <Skeleton 
                                        className={classes.FeatureListSkeleton}
                                    />
                                </>
                                :
                                <>
                                    <li dangerouslySetInnerHTML={createMarkup(pageContent.Feature_2)}/>
                                </>
                            }
                            </ul>
                        </div>  
                        <div id="10" className={classes.gridItem}>
                            <span>{Yes()}</span>
                        </div>
                        <div id="11" className={classes.gridItem}>
                            <span >{Yes()}</span>  
                        </div>  
                        <div id="12" className={classes.gridItem}>
                            <span >{Yes()}</span>
                        </div>
                        <div id="13" className={classes.gridItem}>
                            <ul style={{margin:'0', height:'100%', display:'flex'}}>
                            {
                                isLoadingContent
                                ?
                                <>
                                    <Skeleton 
                                        className={classes.FeatureListSkeleton}
                                    />
                                </>
                                :
                                <>
                                    <li dangerouslySetInnerHTML={createMarkup(pageContent.Feature_3)}/>
                                </>
                            }
                            </ul>
                        </div>
                        <div id="14" className={classes.gridItem}>
                            <span>{No()}</span>
                        </div>  
                        <div id="15" className={classes.gridItem}>
                            <span >{No()}</span>
                        </div>
                        <div id="16" className={classes.gridItem}>
                            <span >{Yes()}</span>
                        </div>
                        <div id="17" className={classes.gridItem}>
                            <ul style={{margin:'0', height:'100%', display:'flex'}}>
                            {
                                isLoadingContent
                                ?
                                <>
                                    <Skeleton 
                                        className={classes.FeatureListSkeleton}
                                    />
                                </>
                                :
                                <>
                                    <li dangerouslySetInnerHTML={createMarkup(pageContent.Feature_4)}/>
                                </>
                            }
                            </ul>
                        </div>
                        <div id="18" className={classes.gridItem}>
                            <span>{No()}</span>
                        </div>
                        <div id="19" className={classes.gridItem}>
                            <span >{Yes()}</span>
                        </div>  
                        <div id="20" className={classes.gridItem}>
                            <span >{Yes()}</span>
                        </div>
                        <div id="21" className={classes.gridItem}>
                            <ul style={{margin:'0', height:'100%', display:'flex'}}>
                            {
                                isLoadingContent
                                ?
                                <>
                                    <Skeleton 
                                        className={classes.FeatureListSkeleton}
                                    />
                                </>
                                :
                                <>
                                    <li dangerouslySetInnerHTML={createMarkup(pageContent.Feature_5)}/>
                                </>
                            }
                            </ul>
                        </div>
                        <div id="22" className={classes.gridItem}>
                            <span>{No()}</span>
                        </div>  
                        <div id="23" className={classes.gridItem}>
                            <span >{Yes()}</span> 
                        </div>
                        <div id="24" className={classes.gridItem}>
                            <span>{Yes()}</span>
                        </div>
                        <div id="25" className={classes.gridItem}>
                            <ul style={{margin:'0', height:'100%', display:'flex'}}>
                            {
                                isLoadingContent
                                ?
                                <>
                                    <Skeleton 
                                        className={classes.FeatureListSkeleton}
                                    />
                                </>
                                :
                                <>
                                    <li dangerouslySetInnerHTML={createMarkup(pageContent.Feature_6)}/>
                                </>
                            }
                            </ul>
                        </div>  
                        <div id="26" className={classes.gridItem}>
                            <span>{No()}</span>
                        </div>
                        <div id="27" className={classes.gridItem}>
                            <span >{No()}</span>
                        </div>  
                        <div id="28" className={classes.gridItem}>
                            <span >{Yes()}</span>
                        </div>
                        <div id="29" className={classes.gridItem}>
                            <ul style={{margin:'0', height:'100%', display:'flex'}}>
                            {
                                isLoadingContent
                                ?
                                <>
                                    <Skeleton 
                                        className={classes.FeatureListSkeleton}
                                    />
                                </>
                                :
                                <>
                                    <li dangerouslySetInnerHTML={createMarkup(pageContent.Feature_7)}/>
                                </>
                            }
                            </ul>
                        </div>
                        <div id="30" className={classes.gridItem}>
                            <span>{No()}</span>
                        </div>  
                        <div id="31" className={classes.gridItem}>
                            <span >{No()}</span>
                        </div>
                        <div id="32" className={classes.gridItem}>
                            <span >{Yes()}</span>
                        </div>
                        <div id="33" className={classes.gridItem}>
                            <ul style={{margin:'0', height:'100%', display:'flex'}}>
                            {
                                isLoadingContent
                                ?
                                <>
                                    <Skeleton 
                                        className={classes.FeatureListSkeleton}
                                    />
                                </>
                                :
                                <>
                                    <li dangerouslySetInnerHTML={createMarkup(pageContent.Feature_8)}/>
                                </>
                            }
                            </ul>
                        </div>
                        <div id="34" className={classes.gridItem}>
                            <span>{No()}</span>
                        </div>
                        <div id="35" className={classes.gridItem}>
                            <span >{Yes()}</span>
                        </div>  
                        <div id="36" className={classes.gridItem}>
                            <span >{Yes()}</span>
                        </div>
                        <div id="37" className={classes.gridItem}>
                            <ul style={{margin:'0', height:'100%', display:'flex'}}>
                            {
                                isLoadingContent
                                ?
                                <>
                                    <Skeleton 
                                        className={classes.FeatureListSkeleton}
                                    />
                                </>
                                :
                                <>
                                    <li dangerouslySetInnerHTML={createMarkup(pageContent.Feature_9)}/>
                                </>
                            }
                            </ul>
                        </div>
                        <div id="38" className={classes.gridItem}>
                            <span>{No()}</span>
                        </div>  
                        <div id="39" className={classes.gridItem}>
                            <span >
                                {No()}
                            </span> 
                        </div>
                        <div id="40" className={classes.gridItem}>
                            <span >{Yes()}</span>
                        </div>
                        <div id="41" className={classes.gridItem}></div>  
                        <div id="42" className={classes.gridItem}>
                            {(() => {
                                if (jwt === null) {
                                return (
                                    <Link
                                        className={'btn ochre'}
                                        to={'/openDictionary/0'}
                                        style={{height:'unset', display:'block'}}
                                    >
                                        <span className={classes.openDict} dangerouslySetInnerHTML={createMarkup(pageContent.open_dictionary_link)} />
                                    </Link>
                                )
                                } else if (jwt !== null && window.localStorage.getItem("account") === "0") {
                                return (
                                    <>{pageContent.free_access}</>
                                )
                                } else if(jwt !== null && window.localStorage.getItem("account") === "2"){
                                return (
                                    <>{pageContent.free_access}</>
                                )
                                }
                            })()}

                            
                        </div>
                        <div id="43" className={classes.gridItem}>
                            {(() => {
                                if (jwt === null) {
                                return (
                                    <Link
                                        className={'btn ochre'}
                                        to={'/registration'}
                                    >
                                        {pageContent.Register_button}
                                    </Link>
                                )
                                } else if (jwt !== null && window.localStorage.getItem("account") === "0") {
                                return (
                                    <Link
                                        to={`/basicDictionary/${window.localStorage.getItem("termId")}`}
                                        className={'btn ochre'}
                                    >
                                        {pageContent.go_back_app_button}
                                    </Link>
                                )
                                } else if(jwt !== null && window.localStorage.getItem("account") === "2"){
                                return (
                                    <></>
                                )
                                }
                            })()}
                           
                            
                        </div>  
                        <div id="44" className={classes.gridItem}>
                            {(() => {
                                if (jwt === null) {
                                return (
                                    <Link
                                        className={'btn ochre'}
                                        to={'/aboutthebook'}
                                        style={{height:'unset'}}
                                    >
                                        {pageContent.get_book_button}
                                    </Link>
                                )
                                } else if (jwt !== null && window.localStorage.getItem("account") === "0") {
                                return (
                                    <Link
                                        className={'btn ochre'}
                                        to={'/aboutthebook'}
                                        style={{height:'unset'}}
                                    >
                                        {pageContent.get_book_button}
                                    </Link>
                                )
                                } else if(jwt !== null && window.localStorage.getItem("account") === "2"){
                                return (
                                    <Link
                                        to={`/dictionary/${window.localStorage.getItem("termId")}`}
                                        className={'btn ochre'}
                                    >
                                        {pageContent.go_back_app_button}
                                    </Link>
                                )
                                }
                            })()}
                            
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div className={classes.AddToHomescreenContainer}>
                <div  className={classes.AddToHomescreen}>
                    <div >
                        <div >
                            <div style={{display:'flex', justifyContent:'center'}}>
                            {
                                isLoadingContent
                                ?
                                <>
                                    <Skeleton 
                                        style={{width:'400px', height:'30px', margin:'35px'}}
                                    />
                                </>
                                :
                                <>
                                    <h3 style={{textAlign:'center'}}>{pageContent.Try_app_title}</h3>
                                </>
                            } 
                            </div>
                            <div style={{maxWidth:'750px'}} className='body_text'>
                            {
                                isLoadingContent
                                ?
                                <>
                                    <Skeleton 
                                        style={{width:'750px', height:'48px', margin:'16px'}}
                                    />
                                </>
                                :
                                <>
                                    <div style={{color:'#292929'}} dangerouslySetInnerHTML={createMarkup(pageContent.Try_app)} />
                                </>
                            } 
                            </div>
                            {
                                isLoadingContent
                                ?
                                <>
                                    <Skeleton 
                                        style={{width:'750px', height:'38px', margin:'16px'}}
                                    />
                                </>
                                :
                                <>
                                   <div style={{margin:'25px', color:'#004F3D', fontFamily:"'Work Sans'", fontSize:'1.6rem', fontWeight:'600', textAlign:'center'}}>{pageContent.Homescreen}</div>
                                </>
                            } 
                            {
                                isLoadingContent
                                ?
                                <>
                                    <Skeleton 
                                        style={{width:'750px', height:'38px', margin:'16px'}}
                                    />
                                </>
                                :
                                <>
                                   <div style={{margin:'25px', color:'#068B77', fontSize:'1.6rem', textAlign:'center', fontFamily:"'Roboto'"}}>{pageContent.IOS_or_Android}</div>
                                </>
                            } 
                            
                            

                        </div>
                        <div>
                            <div style={{display:'flex', justifyContent:'center'}}>
                                <button 
                                    onClick={() => setCurrentOSInfo("Android")} 
                                    style={{
                                        border:'none', 
                                        color:currentOSInfo==="Android"?'#FDFDFD':'#BD8F16',
                                        backgroundColor:currentOSInfo==="Android"?'#BD8F16':'#fdfdfd',
                                        transform:currentOSInfo==="Android"?'scale(1.1)':'scale(1)',
                                        zIndex:currentOSInfo==="Android"?'2':'1'
                                    }}
                                >
                                    Android
                                </button>
                                <button
                                    onClick={() => setCurrentOSInfo("IOS")} 
                                    style={{
                                        border:'none', 
                                        color:currentOSInfo==="IOS"?'#FDFDFD':'#BD8F16',
                                        backgroundColor:currentOSInfo==="IOS"?'#BD8F16':'#fdfdfd',
                                        transform:currentOSInfo==="IOS"?'scale(1.1)':'scale(1)',
                                        zIndex:currentOSInfo==="IOS"?'2':'1'
                                    }}
                                >
                                    iOS
                                </button>
                            </div>
                            {
                                currentOSInfo === "Android"
                                ?
                                <>
                                    <div className={classes.OSIntructions}>
                                        <div>
                                        {
                                            isLoadingContent
                                            ?
                                            <>
                                                <Skeleton 
                                                    style={{width:'250px', height:'30px', margin:'35px'}}
                                                />
                                            </>
                                            :
                                            <>
                                                <div className={classes.OSText} dangerouslySetInnerHTML={createMarkup(pageContent.Android)} />
                                            </>
                                        } 
                                            
                                        </div>
                                        <div className='reveal fade-right active'>
                                            {loadedImg2 ? null : (
                                                <div
                                                style={{
                                                    background: 'trasparent',
                                                    height: '503.5px',
                                                    width: '350px'
                                                }}
                                                />
                                            )}
                                            <img
                                                style={loadedImg2 ? {} : { display: 'none' }}
                                                src={`https://strapi.accounting-a-z.ch${{...{...{...pageContent.Android_image}.data}.attributes}.url}`}
                                                onLoad={() => setLoadedImg2(true)}
                                                className={classes.AddToHomescreenImage}
                                            />
                                        </div>
                                    </div>
                                </>
                                :
                                <>
                                     <div className={classes.OSIntructions} >
                                        <div>

                                        {
                                            isLoadingContent
                                            ?
                                            <>
                                                <Skeleton 
                                                    style={{width:'400px', height:'30px',}}
                                                />
                                            </>
                                            :
                                            <>
                                                <div className={classes.OSText} dangerouslySetInnerHTML={createMarkup(pageContent.IOS)} />
                                            </>
                                        } 
                                        </div>
                                        <div className='reveal fade-right active'>
                                            {loadedImg3 ? null : (
                                                <div
                                                style={{
                                                    background: 'trasparent',
                                                    height: '496.5px',
                                                    width: '350px'
                                                }}
                                                />
                                            )}
                                            <img
                                                style={loadedImg3 ? {} : { display: 'none' }}
                                                src={`https://strapi.accounting-a-z.ch${{...{...{...pageContent.IOS_image}.data}.attributes}.url}`}
                                                onLoad={() => setLoadedImg3(true)}
                                                className={classes.AddToHomescreenImage}
                                            />
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                        
                    </div>                        
                </div>
            </div>
        </section>

        <section>
            <div className={classes.BookAccountPWAContainer}>
                <div className={classes.BookAccountPWA}>
                    <div className={classes.BookAccountPWAIntro}>
                    {
                        isLoadingContent
                        ?
                        <>
                            <Skeleton 
                                className={classes.BookAccountPWAIntroTitleSkeleton}
                            />
                        </>
                        :
                        <>
                             <h3 className={classes.BookAccountPWAIntroTitle}>{pageContent.Have_book_title}</h3>
                        </>
                    } 
                    <div className={classes.BookAccountPWAIntroText} >
                    {
                        isLoadingContent
                        ?
                        <>
                            <Skeleton 
                                className={classes.BookAccountPWAIntroTextSkeleton}
                            />
                            <Skeleton 
                                className={classes.BookAccountPWAIntroTextSkeleton}
                            />
                            <Skeleton 
                                className={classes.BookAccountPWAIntroTextSkeleton}
                            />
                            <Skeleton 
                                className={classes.BookAccountPWAIntroTextSkeleton}
                            />
                            <Skeleton 
                                className={classes.BookAccountPWAIntroTextSkeleton}
                            />
                        </>
                        :
                        <>
                            <div style={{fontFamily:"'Work Sans'", color:'#292929'}} dangerouslySetInnerHTML={createMarkup(pageContent.Have_book)} />
                        </>
                    }     
                    </div>
                    </div>
                    <div className={classes.appInstructions} >
                        <div>
                        <div className={`${classes.BookAccountPWASteps} reveal fade-bottom active`}>
                        {
                            isLoadingContent
                            ?
                            <>
                                <Skeleton 
                                    className={classes.BookAccountPWAStepsSkeleton}
                                />
                                <Skeleton 
                                    className={classes.BookAccountPWAStepsSkeleton}
                                />
                                <Skeleton 
                                    className={classes.BookAccountPWAStepsSkeleton}
                                />
                                <Skeleton 
                                    className={classes.BookAccountPWAStepsSkeleton}
                                />
                               
                            </>
                            :
                            <>
                               <div dangerouslySetInnerHTML={createMarkup(pageContent.Have_book_list)} />
                            </>
                        } 
                            
                        </div>
                        <div className={`${classes.BookAccountPWACallToAction} reveal fade-bottom active`}>
                        {
                            jwt !== null
                            ?
                            <Link
                                to={`/dictionary/${window.localStorage.getItem("termId")}`}
                                className={'btn ochre'}
                            >
                                {pageContent.go_back_app_button}
                            </Link>
                            :
                            <Link
                                to={`/registration`}
                                className={'btn ochre'}
                            >
                                {pageContent.Register_button}
                            </Link>
                        }
                        </div>
                        </div>
                                    
                        <div className={classes.BookAccountPWAImageContainer} >
                        {loadedImg4 ? null : (
                            <div
                            style={{
                                background: 'trasparent',
                                height: '496.5px',
                                width: '350px'
                            }}
                            />
                        )}
                        <img
                            style={loadedImg4 ? {} : { display: 'none' }}
                            src={`https://strapi.accounting-a-z.ch${{...{...{...pageContent.cell_image}.data}.attributes}.url}`}
                            onLoad={() => setLoadedImg4(true)}
                            className={classes.BookAccountPWAImage}
                        />
                        </div>  
                    </div> 
                </div>
            </div>
        </section>
        </>
    )
}


const No = () => {
    return(
        <svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.5 44C10.09 44 0 34.1342 0 22C0 9.86578 10.09 0 22.5 0C34.91 0 45 9.86578 45 22C45 34.1342 34.91 44 22.5 44ZM22.5 0.977778C10.65 0.977778 1 10.4133 1 22C1 33.5867 10.64 43.0222 22.5 43.0222C34.36 43.0222 44 33.5964 44 22C44 10.4036 34.36 0.977778 22.5 0.977778Z" fill="#F33757"/>
            <path d="M15.1099 30.2131C14.9799 30.2131 14.8499 30.1643 14.7599 30.0665C14.5599 29.8709 14.5599 29.5678 14.7599 29.3723L30.2299 14.246C30.4299 14.0505 30.7399 14.0505 30.9399 14.246C31.1399 14.4416 31.1399 14.7447 30.9399 14.9403L15.4699 30.0665C15.3699 30.1643 15.2399 30.2131 15.1199 30.2131H15.1099Z" fill="#F33757"/>
            <path d="M30.5799 30.2131C30.4499 30.2131 30.3199 30.1643 30.2299 30.0665L14.7599 14.9403C14.5599 14.7447 14.5599 14.4416 14.7599 14.246C14.9599 14.0505 15.2699 14.0505 15.4699 14.246L30.9399 29.3723C31.1399 29.5678 31.1399 29.8709 30.9399 30.0665C30.8399 30.1643 30.7099 30.2131 30.5899 30.2131H30.5799Z" fill="#F33757"/>
        </svg>
    )
}

const Yes = () => {
    return(
        <svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.5 44C10.09 44 0 34.1342 0 22C0 9.86578 10.09 0 22.5 0C34.91 0 45 9.86578 45 22C45 34.1342 34.91 44 22.5 44ZM22.5 0.977778C10.65 0.977778 1 10.4133 1 22C1 33.5867 10.64 43.0222 22.5 43.0222C34.36 43.0222 44 33.5964 44 22C44 10.4036 34.36 0.977778 22.5 0.977778Z" fill="#8DD037"/>
            <path d="M18.1599 31.1129C18.0199 31.1129 17.8899 31.0542 17.7999 30.9564L11.1699 24.1511C10.9799 23.9556 10.9899 23.6427 11.1899 23.4569C11.3899 23.2711 11.7099 23.2809 11.8999 23.4764L18.1399 29.8809L32.4099 12.8676C32.5899 12.6622 32.8999 12.6231 33.1099 12.7991C33.3199 12.9653 33.3499 13.2782 33.1799 13.4836L18.5499 30.9173C18.4599 31.0249 18.3199 31.0933 18.1799 31.0933H18.1599V31.1129Z" fill="#8DD037"/>
        </svg>
    )
}

const WorldIcon = () => {
    return(
        <svg width="50" height="50" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M29.5 59C13.2291 59 0 45.7709 0 29.5C0 13.2291 13.2291 0 29.5 0C45.7709 0 59 13.2291 59 29.5C59 45.7709 45.7709 59 29.5 59ZM29.5 1.31111C13.9633 1.31111 1.31111 13.9633 1.31111 29.5C1.31111 45.0367 13.9502 57.6889 29.5 57.6889C45.0498 57.6889 57.6889 45.0498 57.6889 29.5C57.6889 13.9502 45.0498 1.31111 29.5 1.31111Z" fill="#4FB8A8"/>
            <path d="M29.329 45.5037C24.0657 45.5037 21.3271 37.459 21.3271 29.4999C21.3271 21.5408 24.0657 13.4961 29.329 13.4961C34.5923 13.4961 37.3309 21.5408 37.3309 29.4999C37.3309 37.459 34.5923 45.5037 29.329 45.5037ZM29.329 14.4221C25.3507 14.4221 22.7184 21.8831 22.7184 29.4999C22.7184 37.1166 25.5441 44.5777 29.329 44.5777C33.114 44.5777 35.7165 37.1166 35.7165 29.4999C35.4124 18.7623 31.7605 14.4221 29.329 14.4221Z" fill="#4FB8A8"/>
            <path d="M29.5 45.8699C20.4662 45.8699 13.1284 38.5147 13.1111 29.4983C13.1111 20.4645 20.4662 13.1094 29.5 13.1094C38.5338 13.1094 45.8889 20.4645 45.8889 29.4983C45.8889 38.5321 38.5338 45.8872 29.5 45.8872V45.8699ZM29.5 14.8227C21.418 14.8227 14.8417 21.399 14.8417 29.481C14.8417 37.5629 21.418 44.1219 29.5 44.1219C37.5819 44.1219 44.1583 37.5456 44.1583 29.4637C44.1583 21.3817 37.5819 14.8054 29.5 14.8054V14.8227Z" fill="#4FB8A8"/>
            <path d="M43.9221 26.2213H15.0777C13.8769 26.2213 14.4211 25.9328 14.4211 25.5657C14.4211 25.1986 13.8769 24.9102 15.0777 24.9102L43.9221 24.9102C45.1229 24.9102 44.398 25.1986 44.398 25.5657C44.398 25.9328 45.1229 26.2213 43.9221 26.2213Z" fill="#4FB8A8"/>
            <path d="M43.0088 35.7162H15.7334C14.5182 35.7162 14.2414 35.4675 14.2414 35.1511C14.2414 34.8346 13.8626 34.5859 15.0778 34.5859H43.2667C44.4819 34.5859 44.5778 34.8346 44.5778 35.1511C44.5778 35.4675 44.224 35.7162 43.0088 35.7162Z" fill="#4FB8A8"/>
        </svg>
    )
}

const QuestionIcon  = () => {
    return(
        <svg width="50" height="50" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M29.5 59C13.2291 59 0 45.7709 0 29.5C0 13.2291 13.2291 0 29.5 0C45.7709 0 59 13.2291 59 29.5C59 45.7709 45.7709 59 29.5 59ZM29.5 1.31111C13.9633 1.31111 1.31111 13.9633 1.31111 29.5C1.31111 45.0367 13.9502 57.6889 29.5 57.6889C45.0498 57.6889 57.6889 45.0498 57.6889 29.5C57.6889 13.9502 45.0498 1.31111 29.5 1.31111Z" fill="#4FB8A8"/>
            <path d="M22.2888 18.5139C22.6428 18.1468 23.0624 17.8059 23.5082 17.4781C23.967 17.1504 24.4522 16.8488 25.0028 16.5866C25.5404 16.3244 26.1304 16.1146 26.7728 15.9704C27.4153 15.813 28.1102 15.7344 28.8575 15.7344C29.7884 15.7344 30.6668 15.8786 31.4928 16.1539C32.3188 16.4293 33.0399 16.8357 33.6693 17.3601C34.2855 17.8846 34.7837 18.5139 35.1508 19.2744C35.5179 20.0217 35.7015 20.8739 35.7015 21.8048C35.7015 22.8144 35.5442 23.6928 35.2295 24.427C34.9148 25.1613 34.5215 25.8037 34.0364 26.3544C33.5513 26.905 33.0399 27.3901 32.4762 27.8097C31.9124 28.2293 31.3879 28.6226 30.9028 28.9897C30.4177 29.3568 29.9982 29.7239 29.6573 30.1041C29.3164 30.4844 29.1328 30.8908 29.1066 31.3497L28.8706 34.6275H27.5726L27.4677 31.2055V31.1006C27.4677 30.5499 27.625 30.0779 27.9528 29.6584C28.2675 29.2519 28.6739 28.8455 29.1459 28.4522C29.6179 28.0719 30.1293 27.6786 30.693 27.2721C31.2437 26.8788 31.755 26.4199 32.2402 25.9217C32.7122 25.4235 33.1055 24.8466 33.4333 24.1911C33.7479 23.5355 33.9184 22.7619 33.9184 21.8704C33.9184 21.1493 33.7742 20.5068 33.4988 19.943C33.2235 19.3793 32.8433 18.8941 32.3582 18.5008C31.873 18.1075 31.3224 17.8059 30.693 17.5962C30.0637 17.3864 29.4082 17.2815 28.7264 17.2815C27.8479 17.2815 27.0875 17.3995 26.4319 17.6355C25.7895 17.8715 25.2388 18.1206 24.8062 18.4091C24.3604 18.6975 24.0195 18.9597 23.7704 19.1957C23.5213 19.4317 23.3377 19.5497 23.2459 19.5497C23.0493 19.5497 22.905 19.4711 22.8002 19.3137L22.3019 18.5139H22.2888ZM26.327 42.8351C26.327 42.5859 26.3795 42.3368 26.4713 42.1139C26.563 41.891 26.6942 41.6944 26.8646 41.5239C27.035 41.3535 27.2317 41.2224 27.4415 41.1306C27.6644 41.0257 27.9004 40.9733 28.1757 40.9733C28.451 40.9733 28.6739 41.0257 28.8968 41.1306C29.1197 41.2355 29.3164 41.3666 29.4868 41.5239C29.6573 41.6944 29.7884 41.891 29.8933 42.1139C29.9982 42.3368 30.0375 42.5859 30.0375 42.8351C30.0375 43.0973 29.985 43.3464 29.8933 43.5693C29.8015 43.7922 29.6573 43.9888 29.4868 44.1462C29.3164 44.3166 29.1197 44.4477 28.8968 44.5395C28.6739 44.6313 28.4248 44.6837 28.1757 44.6837C27.6513 44.6837 27.2186 44.5133 26.8646 44.1593C26.5106 43.8053 26.3402 43.3726 26.3402 42.8481L26.327 42.8351Z" fill="#4FB8A8"/>
        </svg>
    )
}